export function FileCompressor(file: File, quality = 1) {
  const width = 600; // For scaling relative to width
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onerror = error => reject(error);
    reader.onload = ({ target }) => {
      const img = new Image();
      img.src = target.result as string;
      img.onload = () => {
        const elem = document.createElement('canvas');
        const scaleFactor = width / img.width;
        elem.width = width;
        elem.height = img.height * scaleFactor;
        const ctx = elem.getContext('2d') as CanvasRenderingContext2D;
        ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
        ctx.canvas.toBlob(
          blob => resolve(blobToFile(blob, file?.name)),
          'image/jpeg',
          quality
        );
      };
    };

    reader.readAsDataURL(file as Blob);
  });
}

function blobToFile(blob, name, modified = new Date()) {
  return Object.assign(blob, {
    name,
    lastModifiedDate: modified
  });
}
